import { Box, Flex } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React from "react"
import styled from "styled-components"

import { getUrlProps } from "helpers/landing"

import Image from "./image"
import Textarea from "./textarea"

const Container = styled(Flex).attrs((props) => ({
  alignItems: "flex-end",
  display: { _: "block", tablet: "flex" },
  gutter: { tablet: 2 },
  mb: { _: 6, tablet: 9 },
  ...props,
}))``

const ImageBlock = styled(Box).attrs((props) => ({
  display: "block",
  flex: "2",
  ...props,
}))``

const TextBlock = styled(Box).attrs((props) => ({
  flex: "1",
  ml: { _: 4, tablet: 2 },
  mr: { _: 2, tablet: 0 },
  mt: 3,
  ...props,
}))``

const ImageTextBlock = ({ firstElement, element }) => {
  const urlProps = getUrlProps(
    element?.image?.url,
    null,
    element?.anchor_name || element?.id
  )

  return (
    <Box contain>
      <Container
        alignItems={
          element.element_type === "image_column" ? "flex-end" : "stretch"
        }
        display={element.element_type === "image_column" ? "flex" : "block"}
        flexDirection={{
          _: "column",
          tablet: element.element_type === "image_column" ? "row" : "column",
        }}
        {...element.style}
      >
        <ImageBlock
          order={{
            tablet:
              element.textarea && element.textarea.position === "left" ? 2 : 1,
          }}
          {...urlProps}
          {...element.image.style}
        >
          <Image
            alt={element.title}
            firstElement={!element.textarea && firstElement}
            image={element.image}
            linkClickData={element.id}
          />
        </ImageBlock>
        {element.textarea && (
          <TextBlock
            order={{ tablet: element.textarea.position === "left" ? 1 : 2 }}
            {...element.textarea.style}
          >
            <Textarea
              element={element.textarea}
              firstElement={firstElement}
              linkClickData={element?.anchor_name || element?.id}
            />
          </TextBlock>
        )}
      </Container>
    </Box>
  )
}

ImageTextBlock.propTypes = {
  element: PropTypes.object,
  firstElement: PropTypes.bool,
}

export default ImageTextBlock
